export const FULL_HANDLE_ERROR_MESSAGE =
  "Enter username.1234 with 4-digit discriminator";

export const SCANNED_QR_ERROR_MESSAGE =
  "QR code must contain username.1234 with a 4-digit discriminator.";

export function normalizeFullHandle(value: string): string | null {
  const handle = value.trim().toLowerCase();
  const lastDotIndex = handle.lastIndexOf(".");

  if (lastDotIndex <= 0) {
    return null;
  }

  const discriminator = handle.substring(lastDotIndex + 1);
  if (!/^\d{4}$/.test(discriminator)) {
    return null;
  }

  return handle;
}
